const actions = {
    GET_CUSTOMERS: "customers/GET_CUSTOMERS",
    SET_CUSTOMERS: "customers/SET_CUSTOMERS",

    GET_CUSTOMER: "customers/GET_CUSTOMER",
    SET_CUSTOMER: "customers/SET_CUSTOMER",

    GET_CUSTOMERS_TO_ALLOCATE: "customers/GET_CUSTOMERS_TO_ALLOCATE",
    SET_CUSTOMERS_TO_ALLOCATE: "customers/SET_CUSTOMERS_TO_ALLOCATE",
};

export default actions